












import { Vue, Component } from 'vue-property-decorator'
import { TitleBlockModel } from '../models'
import TitleBlock from '@/components/TitleBlock.vue'
import ItemsAbout from '@/components/ItemsAbout.vue'

@Component({
  components: {
    TitleBlock,
    ItemsAbout
  }
})

export default class BlockAbout extends Vue {
  titles: TitleBlockModel = {
    title: 'Что значит быть самозанятым',
    subtitle: 'Самозанятые работают сами на&nbsp;себя&nbsp;&mdash; у&nbsp;них нет подчинённых и&nbsp;работодателя. Стать самозанятым можно в&nbsp;специальном приложении. Налог для вас будет считаться только с&nbsp;заработанной суммы и&nbsp;по&nbsp;ставке ниже, чем у&nbsp;ИП.'
  }
}
